import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { THEMES, THEME_IDS } from '../components/Themes/themes.js'
import { applyTheme } from '../lib/useTheme.js'

export default function LandingPage() {
  const [i, setI] = useState(0)
  useEffect(() => {
    applyTheme(THEME_IDS[i])
    const id = setInterval(() => setI((x) => (x + 1) % THEME_IDS.length), 3500)
    return () => clearInterval(id)
  }, [i])

  const t = THEMES[THEME_IDS[i]]

  return (
    <div className="min-h-screen flex flex-col bg-app">
      <header className="px-6 py-4 flex items-center justify-between">
        <div className="font-display text-lg tracking-widest">◆ ARISE ◆</div>
        <nav className="flex gap-3 text-sm">
          <Link to="/login"  className="px-3 py-1.5 hover:text-accent">Login</Link>
          <Link to="/signup" className="px-3 py-1.5 rounded-themed border border-card hover:bg-card">
            Sign up
          </Link>
        </nav>
      </header>

      <main className="flex-1 grid place-items-center px-6 py-12">
        <div className="max-w-3xl text-center">
          <div className="label-mini mb-4">Personal Life-RPG</div>
          <h1 className="font-display text-4xl md:text-6xl font-black tracking-tight">
            <span className="text-accent">{t.label}</span>
            <span className="opacity-70"> Mode</span>
          </h1>
          <p className="mt-6 text-lg opacity-80">
            Quests, Kanban, Macros, Books, Streak — alles an einem Ort. Anime-Theme deiner Wahl.
            iPhone-PWA + Desktop, realtime synced.
          </p>
          <div className="mt-10 flex justify-center gap-4">
            <Link to="/signup" className="px-6 py-3 rounded-themed bg-accent font-semibold tap">
              Sign up free
            </Link>
            <Link to="/login" className="px-6 py-3 rounded-themed border border-card tap">
              Have an account?
            </Link>
          </div>
        </div>
      </main>

      <section className="px-6 pb-16 grid grid-cols-2 md:grid-cols-5 gap-4 max-w-5xl mx-auto w-full">
        {[
          ['Quests',  'Macro / Micro / Problem'],
          ['Kanban',  'Drag, archive, undo'],
          ['Macros',  'Food-DB + Coach chat'],
          ['Books',   'Sessions + reflection'],
          ['Streak',  'Heatmap, S-Rank'],
        ].map(([title, sub]) => (
          <div key={title} className="border border-card bg-card rounded-themed p-4">
            <div className="font-display text-sm tracking-widest text-accent">{title}</div>
            <div className="text-xs opacity-70 mt-1">{sub}</div>
          </div>
        ))}
      </section>

      <footer className="px-6 py-6 text-xs opacity-50 text-center">
        No tracking, no ads. Open source spirit.
      </footer>
    </div>
  )
}
